<template><section><h2>toptips</h2>
<demo-block>
                  <div slot="source"><template>
<weui-button @click="showToptips(true)" type="default">显示提示条</weui-button>
<weui-button @click="showToptips(false)" type="default">隐藏提示条</weui-button>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
&lt;weui-button @click=&quot;showToptips(true)&quot; type=&quot;default&quot;&gt;显示提示条&lt;/weui-button&gt;
&lt;weui-button @click=&quot;showToptips(false)&quot; type=&quot;default&quot;&gt;隐藏提示条&lt;/weui-button&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        isVisible: false
      }
    },
    methods: {
      showToptips: function(value) {
        if(value) {
          this.$toptips.show('错误提示', { duration: 0 });
        } else {
          this.$toptips.hide();
        }
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>Event</h2>
<h3>$toptips.show(text, config)</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td>提示内容</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>config</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>duration</td>
<td>显示时长后自动关闭（单位：ms），0 表示永久</td>
<td>number</td>
<td>—</td>
<td>2000</td>
</tr>
</tbody>
</table>
<h3>$toptips.hide()</h3>
<p>关闭提示条</p>
</section></template>

<script>
  export default {
    data() {
      return {
        isVisible: false
      }
    },
    methods: {
      showToptips: function(value) {
        if(value) {
          this.$toptips.show('错误提示', { duration: 0 });
        } else {
          this.$toptips.hide();
        }
      }
    }
  }
</script>